import http from "../../http";

const O2O = "/gateway/apps/o2o/api/o2o";

const goods = {
    /** 店铺商品分页（对齐 uniapp getGoodsBySupplierId） */
    getGoodsBySupplierId(r) {
        return http.get(`${O2O}/goods/getGoodsBySupplierId`, r)
    },
    getGoodsDetail(r) {
        return http.get(`${O2O}/goods/getGoodsDetail`, r)
    },
    getGoodsDetailByGoodsId(r) {
        return http.get(`${O2O}/goods/getGoodsDetailByGoodsId`, r)
    },
    addGood(r) {
        return http.payload(`${O2O}/goods/addGood`, r)
    },
    modifyGoods(r) {
        return http.payload(`${O2O}/goods/modifyGoods`, r)
    },
    deleteGoods(r) {
        return http.post(`${O2O}/goods/deleteGoods`, r)
    },
    modifyGoodsOnSale(r) {
        return http.post(`${O2O}/goods/modifyGoodsOnSale`, r)
    },
    modifyGoodsUnSale(r) {
        return http.post(`${O2O}/goods/modifyGoodsUnSale`, r)
    },
    modifyGoodStock(r) {
        return http.payload(`${O2O}/admin/modifyGoodStock`, r)
    },
    getSupplierCategoryList(r) {
        return http.get(`${O2O}/admin/getSupplierCategoryListBySupplierId`, r)
    },
}
export default goods
